import { __require as requireDefineProperties } from '../define-properties/index.js';
import { __require as requireCallBind } from '../call-bind/index.js';
import { __require as requireImplementation } from './implementation.js';
import { __require as requirePolyfill } from './polyfill.js';
import { __require as requireShim } from './shim.js';

var regexp_prototype_flags;
var hasRequiredRegexp_prototype_flags;

function requireRegexp_prototype_flags () {
	if (hasRequiredRegexp_prototype_flags) return regexp_prototype_flags;
	hasRequiredRegexp_prototype_flags = 1;

	var define = requireDefineProperties();
	var callBind = requireCallBind();

	var implementation = requireImplementation();
	var getPolyfill = requirePolyfill();
	var shim = requireShim();

	var flagsBound = callBind(getPolyfill());

	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});

	regexp_prototype_flags = flagsBound;
	return regexp_prototype_flags;
}

export { requireRegexp_prototype_flags as __require };
